export default {
  consorcios: []
}
